/**
 * getRemainingDays()
 * @param {Date} date Date.
 * @returns {Number} Number of remaining days between a date and today.
 */
export default function getRemainingDays(
  date: Date | undefined,
): number | undefined {
  if (!date || !(date instanceof Date)) return;

  const nowDate = new Date();
  const millisecondsDay = 1000 * 60 * 60 * 24;
  const diffDatesM = date.getTime() - nowDate.getTime(); // Difference in milliseconds
  const diffDatesD = Math.round(diffDatesM / millisecondsDay); // Difference in days

  return diffDatesD;
}
